if (!customElements.get('m-floating-image')) {
  class MFloatingImage extends HTMLElement {
    connectedCallback() {
      this.media = this.querySelector('[data-floating-media]');
      if (!this.media || this.dataset.scrollRotate !== 'true') return;

      this.rotateSpeed = parseFloat(this.dataset.rotateSpeed) || 12;
      this.ticking = false;
      this.onScroll = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }

    disconnectedCallback() {
      if (this.onScroll) {
        window.removeEventListener('scroll', this.onScroll);
      }
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;

      requestAnimationFrame(() => {
        const degrees = window.scrollY * (this.rotateSpeed / 100);
        this.media.style.transform = `rotate(${degrees}deg)`;
        this.ticking = false;
      });
    }
  }

  customElements.define('m-floating-image', MFloatingImage);
}
